module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-notice-bar', {
    attrs: {
      "text": "暂时不支持俱乐部升级申报"
    }
  }), _vm._v(" "), (!_vm.showInfo) ? _c('van-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.jindu != 6),
      expression: "formData.jindu!=6"
    }],
    attrs: {
      "readonly": "",
      "clickable": "",
      "value": _vm.formData.extra_saiqu2.length ? _vm.formData.extra_saiqu2[0].name : '',
      "autosize": "",
      "type": "textarea",
      "input-align": "right",
      "label": "可申请升级赛区",
      "placeholder": "点击选择已报名参赛的赛区"
    },
    on: {
      "click": function($event) {
        _vm.showSaiquPicker2 = true
      }
    }
  }), _vm._v(" "), _c('SaiquPicker', {
    attrs: {
      "show": _vm.showSaiquPicker2,
      "url": "api/sai/clubHeightSaiquOptions",
      "limit": 1,
      "is_online": 2,
      "value": _vm.formData.extra_saiqu2,
      "defaultValue": _vm.formData.extra_saiqu2
    },
    on: {
      "onChange": _vm.onSaiqu2Change,
      "onClose": function($event) {
        _vm.showSaiquPicker2 = false
      },
      "onConfirm": _vm.onSaiqu2Confirm
    }
  }), _vm._v(" "), _c('van-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.jindu != 6),
      expression: "formData.jindu!=6"
    }],
    attrs: {
      "readonly": "",
      "clickable": "",
      "value": _vm.formData.extra_saiqu.length ? _vm.formData.extra_saiqu[0].name : '',
      "autosize": "",
      "type": "textarea",
      "input-align": "right",
      "label": "选择授牌领取的比赛名称",
      "placeholder": "点击选择领取的比赛名称"
    },
    on: {
      "click": function($event) {
        _vm.showSaiquPicker = true
      }
    }
  }), _vm._v(" "), _c('SaiquPicker', {
    attrs: {
      "show": _vm.showSaiquPicker,
      "url": "api/sai/clubGradeSaiquOptions",
      "limit": 1,
      "is_online": 2,
      "value": _vm.formData.extra_saiqu,
      "defaultValue": _vm.formData.extra_saiqu
    },
    on: {
      "onChange": _vm.onSaiquChange,
      "onClose": function($event) {
        _vm.showSaiquPicker = false
      },
      "onConfirm": _vm.onSaiquConfirm
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.county ? _vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county : '',
      "input-align": "right",
      "label": "地区选择",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '不能为空'
      }],
      "label": "俱乐部名称",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入俱乐部名称"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "radio",
      "label": "申报等级",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.formData.grade == '二星'),
            expression: "formData.grade=='二星'"
          }]
        }, [_vm._v("暂无升级方案")]), _vm._v(" "), _c('van-radio-group', {
          model: {
            value: (_vm.formData.bgrade),
            callback: function($$v) {
              _vm.$set(_vm.formData, "bgrade", $$v)
            },
            expression: "formData.bgrade"
          }
        }, [_c('van-radio', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.formData.grade == '一星'),
            expression: "formData.grade=='一星'"
          }],
          attrs: {
            "checked-color": "#ffb01b",
            "name": "二星"
          }
        }, [_vm._v("二星")]), _vm._v(" "), _c('van-radio', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.formData.grade == '三星'),
            expression: "formData.grade=='三星'"
          }],
          attrs: {
            "checked-color": "#ffb01b",
            "name": "三星"
          }
        }, [_vm._v("三星")]), _vm._v(" "), _c('van-radio', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.formData.grade == '四星'),
            expression: "formData.grade=='四星'"
          }],
          attrs: {
            "checked-color": "#ffb01b",
            "name": "四星"
          }
        }, [_vm._v("四星")]), _vm._v(" "), _c('van-radio', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.formData.grade == '五星'),
            expression: "formData.grade=='五星'"
          }],
          attrs: {
            "checked-color": "#ffb01b",
            "name": "五星"
          }
        }, [_vm._v("五星")])], 1)]
      },
      proxy: true
    }], null, false, 3094215616)
  }), _vm._v(" "), _c('van-notice-bar', {
    attrs: {
      "text": "申报二星级俱乐部需有至少一次参赛经历哦"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goWenjuan()
      }
    }
  }, [_vm._v("俱乐部情况调查问卷\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.jindu == 6),
      expression: "formData.jindu==6"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "disabled": true,
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("\n          已授牌\n        ")]), _vm._v(" "), _c('van-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.jindu != 6 && _vm.formData.grade != '二星'),
      expression: "formData.jindu!=6 && formData.grade!='二星'"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          提交申请\n        ")])], 1)], 1) : _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('div', {
    staticStyle: {
      "padding": "0 .2rem"
    }
  }, [_c('ul', {
    staticClass: "step-two-box"
  }, [_c('li', [_vm._v("提交申报信息成功！")]), _vm._v(" "), _c('li', [_vm._v("工作人员会在三个工作日内与您联系。")]), _vm._v(" "), _c('li', [_vm._v("审批通过后，点击 “刷新”按钮，方可")]), _vm._v(" "), _c('li', [_vm._v("进行下一步操作")])])]), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("\n          刷新\n        ")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a8a493d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubHighApply.vue
// module id = 2421
// module chunks = 0